module.exports = __webpack_public_path__ + "img/iu.8fd48085.jpg";